import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenStorageService } from '../../../../services/token-storage/token-storage.service';
import { Observable } from 'rxjs';
import { GlobalConstants } from '../../../../template/common/GlobalConstants';

@Injectable({
  providedIn: 'root'
})
export class ErpGenericService {
    private apiUrl = environment.backendApiUrl;
   //private apiUrl = "http://localhost:8080"
    private headers: HttpHeaders;
    private http = inject(HttpClient)
    private tokenStorage = inject(TokenStorageService)


  constructor() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
   }

   getInterfacesUrl(){
    return `${this.apiUrl}/${GlobalConstants.interfacesReletivePath}`
   }

     getInventories(): Observable<any> {
       const url = `${this.getInterfacesUrl()}/division`;
       return this.http.get(url, { headers: this.headers });
     }

     getUserInventories(email: string): Observable<any> {
      const encodedEmail = encodeURIComponent(email);
    
      const url = `${this.getInterfacesUrl()}/api/users/${encodedEmail}/inventoryOrgs`;
    
      return this.http.get(url, { headers: this.headers });
    }
    findSubinventoriesByInventoryCode(inventoryCode: string): Observable<any> {
    
      const url = `${this.getInterfacesUrl()}/api/par-master/${inventoryCode}/subInventories`;
    
      return this.http.get(url, { headers: this.headers });
    }
}
